removeOptimistic